import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-person',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.scss']
})
export class PersonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  sortby(column: string): void{
    console.log('Tri par la colonne '+ column);
  }

}
